import React from "react";
import { IntervalContextMenuHandler } from "../types";

export const IntervalContextMenuHandlerContext = React.createContext<IntervalContextMenuHandler<any, any>>(() => {});
